import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { OnboardingType } from "../types";

export type InfoStepType =
  | "PENDING_REGISTRY_LOCAL"
  | "PENDING_REGISTRY_REMOTE"
  | "ACTIVE_ACCOUNT"
  | "ACTIVE_ACCOUNT_SUMMARY"
  | "REGISTERED_EMAIL"
  | "DRAFT_NOT_FOUND"
  | "BLACKLIST"
  | "INVALID_PARAMS"
  | "ONBOARDING_IN_PROGRESS"
  | null;

interface InfoStepProps {
  type: InfoStepType;
  pendingOnboardingType?: OnboardingType;
}
const initialState: InfoStepProps = {
  type: null,
};

const infoStepReducer = createSlice({
  name: "infoStep",
  initialState,
  reducers: {
    onUpdateInfoStep: (state, action: PayloadAction<InfoStepType>) => {
      state.type = action.payload;
    },
    onUpdatePendingOnboardingType: (
      state,
      action: PayloadAction<OnboardingType>,
    ) => {
      state.pendingOnboardingType = action.payload;
    },
  },
});

export const { onUpdateInfoStep, onUpdatePendingOnboardingType } =
  infoStepReducer.actions;

export default infoStepReducer.reducer;
